"use client";

import { useState } from "react";
import Link from "next/link";
import GetStartedButton from "./platform/GetStartedButtonLazy";
import ProfileMenu from "./platform/ProfileMenuLazy";
import ThemeToggle from "./ThemeToggle";
import { NAV_GROUPS, NAV_LINKS } from "@/lib/site";

export default function MobileNav() {
  const [open, setOpen] = useState(false);
  const [openGroup, setOpenGroup] = useState<string | null>(null);

  return (
    <div className="lg:hidden">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-label={open ? "Close menu" : "Open menu"}
        aria-expanded={open}
        className="flex h-10 w-10 items-center justify-center rounded-full text-slate-700 transition hover:bg-slate-100 dark:text-slate-200 dark:hover:bg-slate-800"
      >
        {open ? (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} className="h-6 w-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 6l12 12M6 18L18 6" />
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} className="h-6 w-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        )}
      </button>

      {open ? (
        <div className="absolute inset-x-0 top-full border-t border-slate-200 bg-white px-6 py-4 shadow-lg dark:border-slate-800 dark:bg-[#0b1220]">
          <nav className="flex flex-col gap-1">
            {NAV_GROUPS.map((group) => (
              <div key={group.label}>
                <div className="flex items-center justify-between rounded-lg px-2 py-2.5 text-sm font-medium text-slate-700 dark:text-slate-200">
                  <Link href={group.href} onClick={() => setOpen(false)} className="flex-1">
                    {group.label}
                  </Link>
                  {group.children ? (
                    <button
                      type="button"
                      aria-label={openGroup === group.label ? `Collapse ${group.label}` : `Expand ${group.label}`}
                      onClick={() => setOpenGroup((v) => (v === group.label ? null : group.label))}
                      className="flex h-8 w-8 items-center justify-center rounded-full transition hover:bg-slate-100 dark:hover:bg-slate-800"
                    >
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        className={`h-4 w-4 transition ${openGroup === group.label ? "rotate-180" : ""}`}
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 9l6 6 6-6" />
                      </svg>
                    </button>
                  ) : null}
                </div>
                {group.children && openGroup === group.label ? (
                  <div className="ml-2 flex flex-col gap-0.5 border-l border-slate-200 pl-3 dark:border-slate-800">
                    {group.children.map((child) => (
                      <Link
                        key={child.href}
                        href={child.href}
                        onClick={() => setOpen(false)}
                        className="rounded-lg px-2 py-2 text-sm text-slate-600 transition hover:bg-slate-100 dark:text-slate-400 dark:hover:bg-slate-800"
                      >
                        {child.label}
                      </Link>
                    ))}
                  </div>
                ) : null}
              </div>
            ))}
            {NAV_LINKS.map((link) => (
              <Link
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-2 py-2.5 text-sm font-medium text-slate-700 transition hover:bg-slate-100 dark:text-slate-200 dark:hover:bg-slate-800"
              >
                {link.label}
              </Link>
            ))}
          </nav>
          <div className="mt-3 flex items-center justify-between gap-3 border-t border-slate-200 pt-3 dark:border-slate-800">
            <div onClick={() => setOpen(false)}>
              <GetStartedButton />
            </div>
            <div className="flex items-center gap-2">
              <ThemeToggle />
              <ProfileMenu />
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}
